import React from 'react'

const FacebookIcon = ({ ...props }) => (
  <svg width="24" height="24" fill="currentColor" {...props}>
    <path d="M20.182 2H3.818C2.81 2 2 2.81 2 3.818v16.364c0 1 .81 1.818 1.818 1.818h9.091v-8.182h-2.727v-2.727h2.727V9.627c0-2.772 1.355-3.99 3.655-3.99 1.1 0 1.69.081 1.963.118v2.609h-1.573c-.972 0-1.318.518-1.318 1.563v1.164H18.5l-.39 2.727h-2.474V22h4.546c1 0 1.818-.818 1.818-1.818V3.818C22 2.81 21.182 2 20.182 2Z" />
  </svg>
)

export default FacebookIcon
